import { render } from "./ConfirmLogout.vue?vue&type=template&id=486bc4e0&scoped=true"
import script from "./ConfirmLogout.vue?vue&type=script&lang=js"
export * from "./ConfirmLogout.vue?vue&type=script&lang=js"

import "./ConfirmLogout.vue?vue&type=style&index=0&id=486bc4e0&scoped=true&lang=css"
/* custom blocks */
import block0 from "./ConfirmLogout.vue?vue&type=custom&index=0&blockType=section&class=font-poppins"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-486bc4e0"]])

export default __exports__